import { render, staticRenderFns } from "./NewWallPost.vue?vue&type=template&id=b6c97568&"
import script from "./NewWallPost.vue?vue&type=script&lang=js&"
export * from "./NewWallPost.vue?vue&type=script&lang=js&"
import style0 from "./NewWallPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports